<template>
  <!-- 智能安全帽、执法仪、国标智能安全帽 控制面板 组件 -->
  <div class="normalContent" :class="{ 'default-style': $store.state.theme === 'default' }">
    <div class="titleblock">{{ trackPopupInfo.userName }}</div>
    <div class="inforMain">
      <div class="flex_just_between inforMainTitle">
        <div v-if="positionName" class="gpsInfo-gk">
          <span>{{ $t('positionB') }}：</span>
          <span>{{ positionName }}</span>
        </div>
        <div class="gpsInfo-gk">
          <span>{{ $t('time') }}：</span>
          <span>{{ trackPopupInfo.logTimestamp }}</span>
        </div>
        <table>
          <tr>
            <td class="attr">{{ $t('longitude') }}</td>
            <td class="value">{{ showLng.toFixed(6) }}</td>
          </tr>
          <tr>
            <td class="attr">{{ $t('latitude') }}</td>
            <td class="value">{{ showLat.toFixed(6) }}</td>
          </tr>
          <tr v-if="trackPopupInfo.serialNumber">
            <td class="attr">{{ $t('safetyHelmetSerial') }}</td>
            <td class="value">{{ trackPopupInfo.serialNumber }}</td>
          </tr>
          <tr v-if="trackPopupInfo.specModel">
            <td class="attr">{{ $t('specificationModel') }}</td>
            <td class="value">{{ trackPopupInfo.specModel }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocation } from '@/common/map'
import { gcj02_to_wgs84 } from '@/util/wgs84_to_gcj02'
export default {
  name: 'TrackPopup',
  props: {
    // 设备类型
    trackPopupInfo: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      positionName: '',
      showLng: 0,
      showLat: 0,
      theme: '',
    }
  },
  watch: {
    trackPopupInfo: {
      handler: function(val) {
        // 通过坐标获取地理位置
        if (val && val.lng && val.lat) {
          // 传入的精度从wgs84转为了gcj02,调用天地图定位是wgs84，系统显示经纬度一般为wgs84，调整显示数据
          let newPoint = gcj02_to_wgs84(val.lng, val.lat)
          this.showLng = newPoint[0]
          this.showLat = newPoint[1]
          getLocation(newPoint[0], newPoint[1], val => {
            this.positionName = val
          })
        } else {
          this.positionName = ''
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
// 浅色样式
.default-style
  table
    border-color #DCDFE6
    td
      border-color #DCDFE6
    .attr
      background #F4F3F8
      color #0E65DD
    .value
      color #222222

// 通用样式
table
  border 1px solid #3140A7
  font-size 16px
  border-collapse collapse
  margin-top 10px
  td
    border 1px solid #3140A7
    padding  8px 20px
  .attr
    color #5ED8FB
    background #1B2A8D
  .value
    color #FFFFFF
.normalContent
  .titleblock
    height 27px
    line-height 27px
    padding-left 15px
    padding-top 5px
    padding-bottom 5px
    font-size 14px
    font-weight bold
    display flex
  .inforMain
    color #222222
    padding 0px 15px 10px 15px
    .inforMainTitle
      padding 5px 10px
      flex-direction column
    .gpsInfo-gk
      padding 4px 0px
    .no_wrap
      flex-wrap nowrap !important
</style>
